export default __webpack_public_path__ + "static/media/ic-badge-whites.9eca3f77.svg";